import {z} from 'zod';

import {FinancialProductCalculationSchema} from './FinancialProductCalculationSchema';
import {FinancialProductOfferDimensionsSchema} from './FinancialProductOfferDimensionsSchema';
import {FinancialProductUnavailableReasonSchema} from './FinancialProductUnavailableReasonSchema';

/** Availability guarantees that an offer has either a calculation or an unavailable reason. */
const FinancialProductAvailabilitySchema = z.discriminatedUnion('availability', [
  z.object({
    availability: z.literal('AVAILABLE'),
    unavailableReason: z.null(),
    calculation: FinancialProductCalculationSchema,
  }),
  z.object({
    availability: z.literal('UNAVAILABLE'),
    unavailableReason: FinancialProductUnavailableReasonSchema,
    calculation: z.null(),
  }),
]);

/** Unavailable configured products remain present so their dimensions and reason stay visible. */
export const ResolvedFinancialProductOfferSchema = z.intersection(
  FinancialProductOfferDimensionsSchema,
  FinancialProductAvailabilitySchema
);
export type ResolvedFinancialProductOffer = z.infer<typeof ResolvedFinancialProductOfferSchema>;
